/**
 * Playback asks for the current instant through here so a preview can be pinned to another
 * moment — a Monday morning can be checked on a Friday night without waiting for it.
 *
 * The offset is only ever set from the preview URL. On a screen nothing sets it, so now() is
 * Date.now() and every timing decision is unchanged.
 */

// Every player timing decision reads this clock, so a stray value must not be able to throw a
// screen arbitrarily far from the real time.
const MAX_OFFSET_MS = 5 * 366 * 24 * 60 * 60 * 1000

let offsetMs = 0

export function setClockOffset(ms: number): void {
  offsetMs = Number.isFinite(ms) ? Math.max(-MAX_OFFSET_MS, Math.min(MAX_OFFSET_MS, ms)) : 0
}

export function clockOffset(): number {
  return offsetMs
}

export function now(): number {
  return Date.now() + offsetMs
}
